export interface DemoConfig {
  /** Demo hesaplarının ortak parolası: giriş ekranındaki rol kartı bu parolayla NORMAL giriş ucunu çağırır. */
  password: string;
}

export interface AppConfig {
  apiUrl: string;
  /**
   * Demo kipi (ADR 0026): yalnızca demo kurulumunda tanımlanır. Giriş ekranı rol kartlarını ve kullanım kataloğunu
   * gösterir. Üretimde TANIMLANMAZ — parola `/config.js` ile herkese açık olur.
   */
  demo: DemoConfig | null;
}

export interface AppConfigSource {
  apiUrl?: string;
  demo?: { password?: string } | null;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfigSource;
  }
}

/** `/config.js` tarafından sağlanan çalışma zamanı yapılandırmasını okur ve doğrular. */
export function readAppConfig(source: AppConfigSource | undefined = window.__APP_CONFIG__): AppConfig {
  const apiUrl = source?.apiUrl?.trim();
  if (!apiUrl) {
    throw new Error("Uygulama yapılandırması eksik: /config.js içinde apiUrl tanımlı değil.");
  }
  const password = source?.demo?.password?.trim();
  return { apiUrl: apiUrl.replace(/\/+$/, ""), demo: password ? { password } : null };
}
